<template>
    <div id="masterCenter">
        <my-header></my-header>
        <div class="banner">
            <img src="../../assets/images/masterCenter/topBg.jpg"/>
            <div class="main-container">
                <div class="company">
                <span>
                    <img src="../../assets/images/masterCenter/avatar.png"/>
                </span>
                    <strong>{{ companyName}}</strong>
                </div>
            </div>
        </div>
        <section class="main-container main">
            <div class="needDeal">
                <el-tabs>
                    <el-tab-pane>
                        <span slot="label"> 我的待办</span>
                        <a class="more" href="javascript:;" @click="$router.push('/master/more/first')">查看更多&gt;&gt;</a>
                        <ul v-if="watingDealList.length" >
                            <li v-for="(item,index) in watingDealList" :key="index" :class="[ index == 5 ? 'lastLi' : '']">
                                <h4>
                                    <strong @click="toProgress(item,1)">{{ item.dealTitle }}</strong>
                                    <el-button @click="toProgress(item,1)">查看详情</el-button>
                                </h4>
                                <p v-if="item.dealEndTime">
                                    截止日期：<span>{{ item.dealEndTime }}</span>
                                </p>
                            </li>
                        </ul>
                        <p v-else class="none">----暂无待办事项----</p>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label"> 我的已办</span>
                        <a class="more" href="javascript:;" @click="$router.push('/master/more/second')">查看更多&gt;&gt;</a>
                        <ul v-if="hadDealtList.length">
                            <li v-for="(item,index) in hadDealtList" :key="index" :class="[ index == 5 ? 'lastLi' : '']">
                                <h4>
                                    <strong @click="toProgress(item,2)">{{ item.dealTitle }}</strong>
                                    <el-button @click="toProgress(item,2)">查看详情</el-button>
                                </h4>
                                <p v-if="item.dealEndTime">
                                    截止日期：<span>{{ item.dealEndTime }}</span>
                                </p>
                            </li>
                        </ul>
                        <p v-else class="none">----暂无已办事项----</p>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="dealed">
                <h3>
                    我的消息
                </h3>
                <ul v-if="messageList.length">
                    <li v-for="(item,index) in messageList" :key="index" @click="showDialog(item,index)">
                        <h4 class="infoTitle" >
                            <strong>{{ item.msgTitle }}</strong>
                        </h4>
                        <p v-if="item.createDate">
                            消息时间：<span>{{ item.createDate}}</span>
                        </p>
                    </li>
                </ul>
                <p v-else class="none">没有未读消息了~</p>
                <p>
                    <a class="more" href="javascript:;" @click="$router.push('/master/more/third')">查看更多&gt;&gt;</a>
                </p>
            </div>
        </section>
        <el-dialog
            title= '消息通知'
            :visible.sync="dialogVisible"
            @close="closeDialog"
            width="30%">
            <p>{{ dialogTitle }}</p>
            <p>{{ dialogContent ? '详情：'+ dialogContent : ''}}  <el-button type="text" v-if="currentLi.msgType == 12"  @click="download">   点击下载中标通知书 ↓</el-button></p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeDialog">确 定</el-button>
             </span>
        </el-dialog>
        <my-footer></my-footer>
    </div>
</template>
<script>
    import MyHeader from './MasterHeader.vue';
    import MyFooter from "../common/Footer";
    export default {
        name: 'master-center',
        data() {
            return {
                companyName: window.sessionStorage.getItem('companyName'),
                dialogVisible: false,//是否显示弹出层
                dialogTitle: '',
                dialogContent: '',
                watingDealList: [],//我的待办
                hadDealtList: [],//我的已办
                messageList:[],//我的消息列表
                currentId: '',//当前点击的第几个消息的id；
                currentLi: {//当前消息的第几条
                    msgType: '',
                    subRelatedId:''
                },
            }
        },
        components: {MyHeader,MyFooter},
        created(){
            var _this = this;
            this.$root.activeIndex = 'home';
            this.$root.getHttp('/v1/outerformflow/managementCenter',function(res){
//                console.log('全部',res);
                _this.watingDealList = res.data.data.watingDealList;
                _this.hadDealtList = res.data.data.hadDealtList;
                _this.messageList = res.data.data.messageList;

            })
        },
        methods:{
            toProgress(val,entrance){
//                console.log(val)
                if(val.actionType == 202){//邀请函待办
                    this.$router.push('/master/replyInvite/'+val.relatedId+'/'+entrance)
                } else if(val.actionType == 217){//下载标书待办
                    this.$router.push('/master/downloadDoc/'+val.relatedId+'/'+entrance)
                } else {//回标待办
                    this.$router.push('/master/processManagement/'+val.relatedId);
                }
            },
            download(){
                let that = this;
                this.$root.postHttp('/v1/formflow/getSAttachment',{
                    "relatedId": this.currentLi.subRelatedId
                },function (res) {
                    let url = that.$root.baseUrl+'/v1/public/download/download_direct?attachmentPath='+res.data.data.attachPath+'&attachmentName='+encodeURIComponent(res.data.data.attachName);
                    window.location.href= url;
                })
            },
            showDialog(val,index){
                this.currentLi.msgType = val.msgType;
                this.currentLi.subRelatedId = val.subRelatedId;
                var _this = this;
                if(val.jumpFlag == 1){//0 弹框，1 跳转到基本信息 -- 审核记录
                    this.$router.push('/master/basicInfo');
                    window.sessionStorage.setItem('activeNum','3');
                    this.$root.getHttp('/v1/sMessages/readSMessage/'+ val.id,function(res){
                        _this.currentId = val.id;
                    });
                    this.messageList = this.messageList.filter( (item,i) => {
                        return item.id != _this.currentId;
                    });
                } else {
                    this.dialogTitle = val.msgTitle;
                    this.dialogContent = val.msgContent;
                    this.dialogVisible = true;
                    this.$root.getHttp('/v1/sMessages/readSMessage/'+ val.id,function(res){
                        _this.currentId = val.id;
                    })
                }
            },
            closeDialog(){
                var _this = this;
                this.dialogVisible = false;
                this.messageList = this.messageList.filter( (item,i) => {
                    return item.id != _this.currentId;
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/var";
    #masterCenter {
        background: #fff;
        & .head-top{
            background: #fff;
        }
        .banner {
            margin-top: 80px;
            & img {
                width: 100%;
                /*height: 180px;*/
            }
            & .main-container {
                position: relative;
            }
            & .company {
                position: absolute;
                left: 0px;
                bottom: -70px;
                & span {
                    vertical-align: middle;
                    display: inline-block;
                    border: 5px solid #fff;
                    border-radius: 5px;
                    & img {
                        width: 130px;
                        height: 130px;
                    }
                }
                & strong {
                    display: inline-block;
                    vertical-align: middle;
                    margin: 70px 0 0 20px;
                }
            }
        }
        .main {
            margin-top: 100px;
            overflow: hidden;
            padding-bottom: 30px;
            & .needDeal,
            & .dealed {
                float: left;
                padding: 50px 20px 20px;
                box-sizing: border-box;
                border: 1px solid $--secondary-fill-color;
                border-radius: 5px;
                background: #fff;
                & .more {
                    color: $--primary-color;
                   text-decoration: none;
                   font-size: 12px;
                   line-height: 30px;
                }
                .more:hover {
                    text-decoration: underline;
                }
                li strong:hover  {
                    cursor: pointer;
                    color: $--primary-color;
                    text-decoration: underline;
                }
            }
            & .needDeal {
                width: 780px;
                & h3 {
                    overflow: hidden;
                    & img {
                        float: left;
                        width: 224px;
                        height: 30px;
                    }
                    & a {
                        float: right;
                    }
                }
                & ul {
                    margin-top: 15px;
                    & li {
                        padding: 26px 0;
                        border-bottom: 1px solid $--secondary-fill-color;
                        & h4 {
                            overflow: hidden;
                            & strong {
                                float: left;
                                max-width: 350px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                font-size: 14px;
                                line-height: 32px;
                            }
                            & .el-button {
                                float: right;
                                padding: 8px 12px;
                            }
                        }
                        & p {
                            padding-left: 28px;
                            text-align: left;
                            font-size: 12px;
                            line-height: 24px;
                            color: $--text-color-lighter;
                            background: url('../../assets/images/masterCenter/icon01.png') no-repeat;
                        }
                    }
                    & .lastLi {
                        border: none;
                    }
                }
                .el-tabs {
                    position: relative;
                    .el-tabs__content {
                        position: static;
                    }
                    .el-tabs__item {
                        font-size: 16px;
                        width: 120px;
                        height: 32px;
                        padding: 0;
                        line-height: 30px;
                    }
                    .el-tabs__item.is-active {
                        border: 1px solid #cb1235;
                        color: #cb1235;
                        border-radius: 3px;
                        font-weight: 700;
                    }
                    .el-tabs__nav-wrap:after {
                        background-color: #fff;
                    }
                    .el-tabs__active-bar {
                       display:none;
                    }
                }
                .more {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    z-index: 3;
                }
            }
            & .dealed {
                padding-bottom: 50px;
                width: 400px;
                margin-left: 20px;
                & h3 {
                    font-size: 18px;
                }
                & h3::before,
                & h3::after {
                    vertical-align: middle;
                    display: inline-block;
                    content: '';
                    width: 10px;
                    height: 10px;
                    background: url('../../assets/images/masterCenter/titBg.png') no-repeat;
                }
                & ul {
                    margin-top: 25px;
                    max-height: 340px;
                    overflow: hidden;
                }
                & ul li {
                    cursor: pointer;
                    text-align: left;
                    margin: 30px 0;
                    font-weight: bold;
                    .infoTitle {
                        padding: 0 44px 0 24px;
                        /*padding-left: 24px;*/
                        background: url('../../assets/images/masterCenter/icon02.png') no-repeat;
                        font-weight: inherit;
                        height: 24px;
                        font-size: 14px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        strong {
                            font-weight: inherit;
                            display: inline-block;
                            vertical-align: top;
                            width: 150px;
                        }
                    }
                    .infoTitle:hover strong {
                        color: $--primary-color;
                    }
                    p {
                        padding-left: 24px;
                        font-size: 12px;
                        line-height: 24px;
                        color: $--text-color-lighter;
                    }
                }
            }
        }
        .el-dialog {
            .el-dialog__headerbtn .el-dialog__close {
                padding: 3px;
                border: 1px solid #999;
                border-radius: 50%;
                transform: rotate(0deg);
                transition: .5s transform;
            }
            .el-dialog__headerbtn .el-dialog__close:hover {
                transform: rotate(180deg);
                border-color: #cb1235;
            }
            .el-dialog__title {
                font-size: 16px;
                font-weight: 700;
            }
            .el-dialog__body {
                padding-top: 20px;
            }
            p {
                text-align: left;
                text-indent: 2em;
            }
            p:nth-of-type(1){
                font-weight: bold;
                line-height: 34px;
            }
        }
        .none {
            margin: 55px 0 70px;
            font-size: 16px;
            line-height: 40px;
            color: $--text-color-lighter;
            border: 1px solid $--text-color-lighter;
            border-radius: 3px;
        }
        .needDeal .none {
            border: none;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/MasterCenter.vue